import { networkAction } from "helpers/network/networkAction";

import {
  GET_COURSES,
  GET_COURSE_BY_ID,
  DELETE_COURSE,
  UPDATE_COURSE,
  CREATE_COURSE,
} from "constants/courses";

import * as Api from "api";

export const getCourses = (filters) => async (dispatch) =>
  networkAction(dispatch, GET_COURSES, Api.getCourses, [filters]);

export const getCourseById = (id) => async (dispatch) =>
  networkAction(dispatch, GET_COURSE_BY_ID, Api.getCourseById, [id]);

export const getCourseModules = (id) => async (dispatch) =>
  networkAction(dispatch, GET_COURSE_BY_ID, Api.getCourseModules, [id]);

export const deleteCourse = (id) => async (dispatch) =>
  networkAction(dispatch, DELETE_COURSE, Api.deleteCourse, [id]);

export const createCourse = (body) => async (dispatch) =>
  networkAction(dispatch, CREATE_COURSE, Api.createCourse, [body]);

export const updateCourse = (id, body) => async (dispatch) =>
  networkAction(dispatch, UPDATE_COURSE, Api.updateCourse, [id, body]);
